import React from 'react';
export function PresentationFrame({
  children
}: {
  children: ReactNode;
}) {
  return <div className="h-[100dvh] w-full bg-gradient-to-br from-[#E6EEF7] via-[#EFF5FB] to-[#DDE8F3] flex items-center justify-center relative overflow-hidden" data-id="element-90">
      {/* Ambient glow */}
      <div className="absolute w-[900px] h-[900px] bg-minerva-blue/15 rounded-full blur-[200px] pointer-events-none" data-id="element-91" />
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-minerva-cyan/10 rounded-full blur-[160px] pointer-events-none" data-id="element-92" />

      {/* Full-viewport stage */}
      <div className="relative w-full h-full max-w-[2200px] mx-auto bg-gradient-to-b from-white via-[#F8FBFE] to-[#EEF4FA] overflow-hidden flex flex-col" data-id="element-93">
        {children}
      </div>
    </div>;
}